<main class="content-page">
  <section class="content-hero">
    <p class="content-kicker">{{ 'pages.services.kicker' | translate }}</p>
    <h1>{{ 'pages.services.title' | translate }}</h1>
    <p>{{ 'pages.services.lead' | translate }}</p>
  </section>

  <section class="detail-grid" aria-label="Virágbolt szolgáltatások">
    <article class="detail-card" *ngFor="let service of services">
      <img [src]="service.image" [alt]="service.altKey | translate" />
      <div>
        <h2>{{ service.titleKey | translate }}</h2>
        <p>{{ service.leadKey | translate }}</p>
        <ul>
          <li *ngFor="let featureKey of service.featureKeys">
            {{ featureKey | translate }}
          </li>
        </ul>
      </div>
    </article>
  </section>

  <section class="content-band">
    <div>
      <p class="content-kicker">{{ 'pages.services.orderKicker' | translate }}</p>
      <h2>{{ 'pages.services.orderTitle' | translate }}</h2>
      <p>{{ 'pages.services.orderText' | translate }}</p>
    </div>
    <div class="content-actions">
      <a
        class="content-button primary"
        href="https://shop.twogetherflower.hu"
        target="_blank"
        rel="noopener"
      >
        {{ 'pages.shared.shop' | translate }}
      </a>
      <a
        class="content-button"
        href="https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more"
        target="_blank"
        rel="noopener"
      >
        {{ 'pages.shared.wolt' | translate }}
      </a>
      <a class="content-button" href="tel:+36300121051">{{ 'pages.shared.call' | translate }}</a>
    </div>
  </section>
</main>
